import { NgModule } from '@angular/core';
import {
  MatInputModule,
  MatDialogModule,
  MatButtonModule,
  MatMenuModule,
  MatIconModule,
  MatSnackBarModule
} from '@angular/material';

@NgModule({
  imports: [
  ],
  exports: [
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatSnackBarModule
  ],
})
export class MaterialModule { }
